const SegmentType = Object.freeze({
  FAVOURITES: "Favourites",
  RECENTS: "Recents",
});

export default SegmentType;
